import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { useUser } from "../contexts/UserContext/UserContext";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
    const { state, myCompanyData } = useUser();
    const isOnboardingRoute = rest.path === "/onboarding";

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                // Check authentication first
                if (!state?.user.id || !state?.isAuthenticated) {
                    return <Redirect to={"/login"} />;
                }

                // Check onboarding status for non-onboarding routes
                if (!isOnboardingRoute && myCompanyData) {
                    const isOnboardingCompleted = myCompanyData?.onboardingSteps?.completed;

                    // Redirect to onboarding if not completed or undefined.
                    // A Stripe return must keep its query params, otherwise the
                    // wizard cannot tell which step to restore and resets to the
                    // first one. Other redirects drop the search deliberately.
                    if (isOnboardingCompleted === false || isOnboardingCompleted === undefined) {
                        const { search } = routeProps.location;
                        const isStripeReturn = /stripe-onboard-connection-(success|failed)/.test(search);
                        return <Redirect to={{ pathname: "/onboarding", search: isStripeReturn ? search : "" }} />;
                    }
                }

                return <RouteComponent {...routeProps} />;
            }}
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
